import { getRoles } from '../api/ROLES/roles';
import { useQuery } from '@tanstack/react-query';

export const useRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: getRoles,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
